import React, { useEffect } from "react";

import {
	Box,
	FormControl,
	Typography,
	InputLabel,
	Select,
	MenuItem,
	TextField,
	Grid,
	Checkbox,
	FormControlLabel,
	Button,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { getCustsAndCGs, setState } from "./editScenarioNewSlice";

const commonHeight = sizes.h35;
const SW = sizes.w300;

export default function CustomerCgSearchForm() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.editScenarioNew);
	const {
		customerLevels,
		customerTypes,
		trustLevels,
		customerCategories,
		selectedCL,
		selectedCustType,
		selectedTL,
		selectedCustCat,
		customerName,
		activeCustomerOnly,

		countryID,
		selectedCTCode,
		selectedCLID,
		selectedTLID,
		selectedCCID,

		selectedCountry,
		selectedPGs,

		editScDetails,
	} = setupState;

	function setCustomerInfoFromSelectedScenario() {
		dispatch(
			setState(
				"selectedCL",
				editScDetails.customers[0].customer.customerLevel
			)
		);
		dispatch(setState("selectedCLID", editScDetails.scenarioLevel));

		const typeCode = editScDetails.customers[0].customer.customerTypeCode;
		const type = customerTypes.find(
			(custType) => custType.customerTypeCode === typeCode
		).customerTypeName;

		dispatch(setState("selectedCustType", type));
		dispatch(setState("selectedCTCode", typeCode));
	}

	function setCGInfoFromSelectedScenario() {
		dispatch(setState("selectedCLID", editScDetails.scenarioLevel));
		const level = customerLevels.find(
			(level) => level.customerLevelID === editScDetails.scenarioLevel
		).customerLevel;
		dispatch(setState("selectedCL", level));

		dispatch(
			setState(
				"selectedCTCode",
				editScDetails.customerGroups[0].customerGroup.customerGroupTypeCode
			)
		);
		const type = customerTypes.find(
			(t) =>
				t.customerTypeCode ===
				editScDetails.customerGroups[0].customerGroup.customerGroupTypeCode
		).customerTypeName;
		dispatch(setState("selectedCustType", type));
	}

	useEffect(() => {
		if (editScDetails !== null) {
			// if (editScDetails.customers.length > 0) {
			// 	setCustomerInfoFromSelectedScenario();
			// } else if (editScDetails.customerGroups.length > 0) {
			// 	setCGInfoFromSelectedScenario();
			// }
			// dispatch(setState("selectedTL", "All"));
			// dispatch(setState("selectedCustCat", "All"));
		}
	}, [editScDetails]);

	useEffect(()=>{
		let categories = [...customerCategories];
		if(selectedCL === "Ship-to"){
			categories = categories.filter(cat => cat !== "Customer Type");
		}else if(selectedCL === "Sold-to"){
			let idx = categories.indexOf("Customer Type");
			if(idx === -1){
				categories.push("Customer Type");
			}
		}
		if(selectedCCID === 3 && selectedCL === "Ship-to") {
			dispatch(setState("selectedCCID", 0));
			dispatch(setState("selectedCustCat", "All"));
		}
		dispatch(setState("customerCategories", categories));
	},[selectedCL])

	const handleCustomerLevel = (event) => {
		const level = event.target.value;
		dispatch(setState("selectedCL", level));
		const id = customerLevels.find(
			(custLevel) => custLevel.customerLevel === level
		).customerLevelID;
		dispatch(setState("selectedCLID", id));
		dispatch(setState("selectedCustsCGs",[]));
		dispatch(setState("custsCGs",[]));
	};

	const handleCustType = (event) => {
		const type = event.target.value;
		dispatch(setState("selectedCustType", type));
		if (type === "All") {
			dispatch(setState("selectedCTCode", "All"));
		} else {
			const found = customerTypes.find(
				(custType) => custType.customerTypeName === type
			);
			const code = found ? found.customerTypeCode : "";
			dispatch(setState("selectedCTCode", code));
		}
	};

	const handleRelationshipLevel = (event) => {
		const level = event.target.value;
		dispatch(setState("selectedTL", level));
		let id = "";
		if (level === "All") {
			id = 0;
		} else {
			id = trustLevels.find((tL) => tL.trustDesc === level).trustLevelID;
		}
		dispatch(setState("selectedTLID", id));
	};

	const handleCustCat = (event) => {
		const custCat = event.target.value;
		dispatch(setState("selectedCustCat", custCat));
		if (custCat === "All") {
			dispatch(setState("selectedCCID", 0));
		} else if (custCat === "Individual Customer") {
			dispatch(setState("selectedCCID", 1));
		} else if (custCat === "Customer Group") {
			dispatch(setState("selectedCCID", 2));
		} else if(custCat === "Customer Type") {
			dispatch(setState("selectedCCID", 3));
		}
	};

	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		dispatch(setState(stateName, value));
	};

	const handleCheckedUpdate = (event, stateName) => {
		const option = event.target.checked;
		dispatch(setState(stateName, option));
	};

	const handleSearchCustAndCG = () => {
		if (selectedCountry.length <= 0) {
			showMessage("Please select a country", "info");
			return;
		}
		if (selectedPGs.length <= 0) {
			showMessage("Please select at least one SKU or product group", "info");
			return;
		}
		if (selectedCL.length <= 0) {
			showMessage("Please select a customer level", "info");
			return;
		}
		if (selectedCustType.length <= 0) {
			showMessage("Please select a customer type", "info");
			return;
		}
		if (selectedTL.length <= 0) {
			showMessage("Please select a relationship level", "info");
			return;
		}
		if (selectedCustCat.length <= 0) {
			showMessage("Please select a customer category", "info");
			return;
		}
		let obj = {
			countryID : countryID,
			CstTypeCode : selectedCTCode,
			CstLvlCode : selectedCLID,
			CstName : customerName,
			ActiveCst : activeCustomerOnly,
			trstLvl :selectedTLID,
			category : selectedCCID

		}
		dispatch(
			getCustsAndCGs({
				obj
			})
		);
	};

	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	return (
		<Box
			sx={{
				mt: 5,
			}}
		>
			{/* <Box sx={{ mt: 4, mb: 3, }}>
				<Typography sx={{ color: "lightBlue.main", fontWeight: "bold" }} className="compHeading">
					Select Customer Groups/Customers
				</Typography>
			</Box> */}

			<Box>
				<Grid container columns={12} spacing={2} pb={1} >
					<Grid item xs={12} md={5.4} lg={11.5}>
						<Box>
							<FormControl sx={{width:"100%"}}>
								<InputLabel id="demo-simple-	select-label">
									Level
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={selectedCL}
									label="level"
									onChange={handleCustomerLevel}

									sx={{
										height: commonHeight,
										width: SW,
										color: "black.main",
										mt: 1,
									  }}
								>
									{customerLevels.map((level, index) => {
										return (
											<MenuItem
												key={index}
												value={level.customerLevel}
											>
												{level.customerLevel}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid>

					<Grid item xs={12} md={5.4} lg={11.5}>
						<Box>
							<FormControl sx={{width:"100%"}}>
								<InputLabel id="demo-simple-select-label">
									Type
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={selectedCustType}
									label="type"
									sx={{
										height: commonHeight,
										width: SW,
										color: "black.main",
										mt: 1,
									}}
								onChange={handleCustType}
								>
                  <MenuItem value="All">All</MenuItem>
                 {customerTypes.map((type, index) => (
									(type.customerTypeCode === 'P20' || type.customerTypeCode === 'P27' || type.customerTypeCode === 'P31' || type.customerTypeCode === 'P30') ? (
										<MenuItem key={index} value={type.customerTypeName} disabled={!type.customerTypeCode}>
											{type.customerTypeCode ? `${type.customerTypeCode} | ` : ''}{type.customerTypeName}
										</MenuItem>
									) : null
								))}
								<div style={{ borderBottom: "dashed 1px", paddingBottom: "10px" }}></div>
								{customerTypes.map((type, index) => (
									(type.customerTypeCode !== 'P20' && type.customerTypeCode !== 'P27' && type.customerTypeCode !== 'P31' && type.customerTypeCode !== 'P30') ? (
										<MenuItem key={index} value={type.customerTypeName} disabled={!type.customerTypeCode}>
											{type.customerTypeCode ? `${type.customerTypeCode} | ` : ''}{type.customerTypeName}
										</MenuItem>
									) : null
								))}
								</Select>
							</FormControl>
						</Box>
					</Grid>

					<Grid item xs={12} md={5.4} lg={11.5}>
						<Box>
							<FormControl sx={{width:"100%"}}>
								<InputLabel id="demo-simple-select-label">
									Relationship Level
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={selectedTL}
									label="Relationship Level"
									sx={{
										height: commonHeight,
										width: SW,
										color: "black.main",
										mt: 1,
									}}
									onChange={handleRelationshipLevel}
								>
									<MenuItem value="All">All</MenuItem>
									{trustLevels.map((level, index) => {
										return (
											<MenuItem key={index} value={level.trustDesc}>
												{level.trustDesc}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid>

					<Grid item xs={12} md={5.4} lg={11.5}>
						<Box>
							<FormControl sx={{width:"100%"}}>
								<InputLabel id="demo-simple-select-label">
									Customer Category
								</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={selectedCustCat}
									label="Customer Category"
									sx={{
										height: commonHeight,
										width: SW,
										color: "black.main",
										mt: 1,
									}}
									onChange={handleCustCat}
								>
									{customerCategories.map((category, index) => {
										return (
											<MenuItem key={index} value={category}>
												{category}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid>

					<Grid item xs={12} md={5.4} lg={11.5}>
						<Box>
							<TextField
								id="outlined-basic"
								label="Search Customer"
								sx={{width:"100%"}}
								value={customerName}
								onChange={(event) =>
									handleStateUpdate(event, "customerName")
								}
								InputProps={{ autoComplete: "off" }}
								
							/>
						</Box>
					</Grid>

					<Grid item xs={12} md={5.4} lg={11.5}>
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								justifyContent: "flex-start",
								mt: 1,
								
							}}
						>
							<FormControlLabel
								control={
									<Checkbox
										checked={activeCustomerOnly}
										onChange={(event) =>
											handleCheckedUpdate(
												event,
												"activeCustomerOnly"
											)
										}
										InputProps={{ "aria-label": "controlled" }}
										//sx={{ ml: 1 }}
									/>
								}
							/>

							<Typography sx={{ mt: 1.3, ml:-2, }}>
								Active Customers Only
							</Typography>
						</Box>
					</Grid>

					
				</Grid>
				<Grid item xs={12} md={5.4} lg={11.5}>
						<Box>
							<Button
								startIcon={<SearchIcon />}
								sx={{
									bgcolor: "darkBlue.light",
									color: "white.main",
									textTransform: "none",
									mt: 1,
									"&:hover": {
										bgcolor: "darkBlue.main",
									},
									marginLeft:"calc(100% - 120px)"
								}}
								onClick={handleSearchCustAndCG}
							>
								Search
							</Button>
						</Box>
					</Grid>
			</Box>

			
		</Box>
	);
}
